import React from "react";
import { Link, Box, TextField, Typography } from "@mui/material";
//Assets
// Local
import {
  Form,
  Navigation,
  useFormik,
  useLocation,
  yup,
  RouterLink,
} from "../../lib";
import {
  ContainerStyle,
  FormStyle,
  TextFlexStyle,
  CenterElementStyle,
  ButtonStyle,
} from "./Auth.styles";
import { actions } from "../../state/rtk-query";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
});

export const ForgotPasswordPage = React.memo(
  /**
   *
   */
  function ForgotPasswordPage() {
    const location = useLocation();
    const { useAuthForgotPasswordMutation } = actions;
    const [recoverPassword] = useAuthForgotPasswordMutation();
    const frm = useFormik({
      initialValues: {
        email: location.query.email || "",
      },
      validationSchema,
      async onSubmit(values) {
        recoverPassword({ body: values });
        Navigation.go(
          `/auth/recovery-sent?email=${encodeURIComponent(values.email)}`,
        );
      },
    });

    return (
      <ContainerStyle>
        <Box>
          <Typography variant="h1" gutterBottom fontWeight={600}>
            Reset Password
          </Typography>

          <Typography
            variant="body1"
            gutterBottom
            fontWeight={500}
            fontSize={16}
          >
            Enter your email we'll send you a link to reset your password. If
            you don't have an email reach out to the office.
          </Typography>

          <FormStyle>
            <Form form={frm}>
              <TextFlexStyle>
                <TextField
                  autoFocus
                  fullWidth
                  id="email"
                  name="email"
                  label="Email"
                  value={frm.values.email}
                  onChange={frm.handleChange}
                  error={frm.touched.email && Boolean(frm.errors.email)}
                  helperText={
                    !!frm.touched.email && (frm.errors.email as string)
                  }
                />
              </TextFlexStyle>
              <ButtonStyle
                variant="contained"
                type="submit"
                disabled={frm.isSubmitting}
                fullWidth
              >
                Email me a reset link
              </ButtonStyle>
              <CenterElementStyle>
                <Link component={RouterLink} to={`/auth/login`}>
                  <Typography variant="body2"> Back to login </Typography>
                </Link>
              </CenterElementStyle>
            </Form>
          </FormStyle>
        </Box>
      </ContainerStyle>
    );
  },
);
